import { Box, Button, Checkbox, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import UserCard from '../UserCard';
import DataService from '../../../../../../../Service';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../../../../Components/Snackbar/SnackbarActions';
const useStyles = makeStyles((theme) => ({
    in_active: {
        backgroundColor: "#CECFD0",
        color: "#707070"
    },


}));

const LongList = (props) => {
    const classes = useStyles();

    const [emailModal, setEmailModal] = useState("");
    const [checked, setChecked] = useState([]);
    const [checkedAllState, setCheckedAllState] = useState();
    const [pageData, setPageData] = useState([]);
    const [checkedLength, setCheckedLength] = useState([]);
    var localArr = [];
    const dispatch = useDispatch();

    useEffect(() => {
        getCoachList()
    }, [])

    const getCoachList = () => {
        DataService.getDirectData("shortlisting_coaches/fetch_longlist_coaches", { assignment_id: props.location.state.currentAssignment.id })
            .then((res) => {
                pageData.length = 0;
                setPageData(pageData.concat(res.longlist_coaches))
            })
    }

    const moveToShortList = (params) => {
        var localArr = [];
        for (const key in checked) {
            if (checked[key]) {
                localArr.push({ "coach_id": key })
            }
        }
        const pdata = {
            assignment_id: props.location.state.currentAssignment.id,
            shortlist_coaches: localArr
        }
        DataService.createData(pdata, 'move_to_shortlist')
            .then((res) => {
                if(res.success){
                dispatch(showSnackbar("Success", ["Coach moved to shortlist successfully"]))
                props.setValue(props.value + 1)
                }
            })
            .catch((err) => {
                console.log("error", err);
                dispatch(showSnackbar("error", [["" + err.message]]));
      
              });

    }

    const getArrLengthForClasses = (obj) => {
        for (const key in obj) { localArr.push(obj[key]) }
        var activeArr = localArr.filter((option) => option == true);
        checkedLength.length = 0;
        setCheckedLength(checkedLength.concat(activeArr))
    }

    const checkHandler = (e) => {
        console.log(e.target.value, typeof (e.target.value), pageData)
        let checkedValue = {};
        if (e.target.value === "checkedAll") {
            pageData?.map(data => checkedValue[data.coach_id] = data.shortlist_type === "longlist" ? e.target.checked : undefined)
            console.log("checkedAll", checkedValue)
            setCheckedAllState(e.target.checked)

        } else {
            checkedValue = { ...checked, [e.target.value]: e.target.checked }
        }
        setChecked({ ...checked, ...checkedValue })
        getArrLengthForClasses(checkedValue)
    }


    return <Box>
        <Grid container direction="row" spacing={2} alignItems="center">
            {pageData.length > 0 &&
                <>
                    <Grid item xs={1} style={{
                        justifyContent: "center", flexBasis: "0"
                    }}>
                        <Checkbox
                            onChange={checkHandler}
                            value="checkedAll"
                            checked={checkedAllState}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h2">Select All</Typography>
                    </Grid>
                </>
            }
            {console.log("pageData", pageData)}
            <Grid item xs={pageData.length > 0 ? 6 : 12}>
                <Typography variant="h6">
                    <Box fontWeight="fontWeightBold" my={2} textAlign="right">
                        <Button disableElevation disabled={checkedLength.length === 0 ? true : false} variant="contained" color="secondary" onClick={moveToShortList} className={checkedLength.length == 0 ? classes.in_active : {}} style={{ textTransform: "none" }}><PersonOutlineIcon color="#707070" />&nbsp;Move to shortlist</Button>
                    </Box>
                </Typography>
            </Grid>
        </Grid>
        {
            pageData.length > 0 && pageData?.map((option) => {
                return <Box mb={3}>
                    <Grid container direction="row" spacing={1} >
                        <Grid item xs={1} style={{ justifyContent: "center", flexBasis: "0", margin: "48px 0px" }}>
                            <Checkbox
                                onChange={checkHandler}
                                disabled={option?.shortlist_type === "shortlist" || option?.shortlist_type === "confirmed" || option?.shortlist_type === "chemistry"}
                                checked={checked[option?.coach_id] === undefined ? false : checked[option?.coach_id]}
                                value={option?.coach_id}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={11} style={{ marginLeft: "0px", border: "solid 1px", borderColor: "#CACED5" }}>
                            <UserCard emailModal={emailModal} setEmailModal={setEmailModal} moved={option?.shortlist_type === "shortlist" || option?.shortlist_type === "confirmed" || option?.shortlist_type === "chemistry"} buttonText={option?.shortlist_type} hideEmail={true} {...props} pageData={option||{}} />
                        </Grid>
                    </Grid>
                </Box>
            })
        }
    </Box >
    // <div>
    //    <UserCard/>
    // </div>

}

export default LongList
